import { render, staticRenderFns } from "./monitorVideo.vue?vue&type=template&id=771ce47a&scoped=true&"
import script from "./monitorVideo.vue?vue&type=script&lang=js&"
export * from "./monitorVideo.vue?vue&type=script&lang=js&"
import style0 from "./monitorVideo.vue?vue&type=style&index=0&id=771ce47a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ce47a",
  null
  
)

export default component.exports